<template>
  <van-tabbar v-model="type" @change="onChange" active-color="#b8860b" inactive-color="#64748b" style="border-top: 1px solid #eef0f3; box-sizing: border-box; background-color: #ffffff; z-index: 200">
    <van-tabbar-item>
      <span>首页</span>
      <template #icon="props">
        <div class="footIco" :class="{ on: props.active }"><img src="/static/image/nav/home.png" /></div>
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>优惠</span>
      <template #icon="props">
        <div class="footIco" :class="{ on: props.active }"><img src="/static/image/nav/promo.png" /></div>
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>存款</span>
      <template #icon="props">
        <div class="footIco" :class="{ on: props.active }"><img src="/static/image/nav/deposit.png" /></div>
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>提现</span>
      <template #icon="props">
        <div class="footIco" :class="{ on: props.active }"><img src="/static/image/nav/withdraw.png" /></div>
      </template>
    </van-tabbar-item>
    <van-tabbar-item>
      <span>我的</span>
      <template #icon="props">
        <div class="footIco" :class="{ on: props.active }"><img src="/static/image/nav/mine.png" /></div>
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>
<script>
//
export default {
  name: 'Foot',
  data() {
    return { type: 0 };
  },
  methods: {
    onChange(type) {
      let that = this;
      if (type == 0) {
        that.$parent.goNav(`/`);
      }
      if (type == 1) {
        that.$parent.goNav(`/activity`);
      }
      if (type == 2) {
        that.$parent.goNav(`/recharge`);
      }
      if (type == 3) {
        that.$parent.goNav(`/withdrawal`);
      }
      if (type == 4) {
        that.$parent.goNav(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/') {
        that.type = 0;
      } else if (path == '/activity') {
        that.type = 1;
      } else if (path == '/recharge') {
        that.type = 2;
      } else if (path == '/withdrawal') {
        that.type = 3;
      } else if (path == '/mine') {
        that.type = 4;
      } else {
        that.type = 5;
      }
    },
  },
  mounted() {},
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.footIco {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  transition: all 0.15s ease;
  img {
    height: 30px;
    display: block;
    filter: grayscale(30%);
    opacity: 0.72;
    transition: all 0.15s ease;
  }
}
.footIco.on {
  background: rgba(198, 154, 63, 0.15);
  img {
    filter: none;
    opacity: 1;
  }
}
.van-tabbar-item {
  font-size: 14px;
}
.van-tabbar {
  height: 68px;
}
.van-tabbar-item--active {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/libs/Foot.vue